// const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const {PLAYWRIGHT_TEST_IDS} = require("../../../shared/PlaywrightTestIds");
const {Portal} = require("./Portal");
const _ = require("lodash");

const Link = require("./Link");
const AT = require("../vault/ActionTypes");
const OpsUser = require("../vault/OpsUser");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const URLMake = require("../../../shared/URLMake");
// const NumberUtil = require("../util/Numbers.js");
const HoverRegion = require("./HoverRegion");
const DropdownContainer = require("./DropdownContainer");
const Quad = require("./Quad");
const QuadUtil = require("../util/QuadUtil");
const Sounds = require("../util/Sounds");
const AssetsUtil = require("../util/AssetsUtil");
const IconButton = require("./IconButton");
const BucksOdometer = require("./BucksOdometer");
const Avatar = require("./Avatar");
const dbDemoData = require("../../../shared/data/dbDemoData.json");
const styles = require("./styles/TopBarUser.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "TopBarUser",

		propTypes: {
			user: PT.object.isRequired,
			page: PT.object.isRequired,
			demo: PT.bool,
			isStatic: PT.bool, // Use as tutorial "screenshot"
			className: PT.string,
			masked: PT.bool,

			// Tutorial props
			hideProfile: PT.bool,
			hijackClick: PT.func,
			fadeIn: PT.bool,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				userDropdown: false,
				pullOutHover: false,
			};
		},

		openDropdown: function() {
			this.setState({
				userDropdown: true,
			});
		},

		closeDropdown: function() {
			this.setState({
				userDropdown: false,
			});
		},

		logout: function() {
			Sounds.playSound("logout");
			this.props.dispatch({
				type: AT.LOGOUT_USER_REQUEST,
			});
		},

		render: function() {
			const {page, user, demo} = this.props;
			const userModel = user.model;
			const displayName = demo ? "Guest" : userModel.displayName;
			const pageName = page.name;
			const avatarModel = this.props.demo
				? dbDemoData.avatarModel
				: user.model.avatar;

			const bucks = OpsUser.canAccessBeastbuilder(user) ? (
				<BucksOdometer className={styles.bucks} bucks={userModel.bucks} />
			) : null;

			// Dropdown is actually pullout, but they work the same way
			let pullOut;

			const quad = (
				<Quad
					quad={QuadUtil.quadTable.pullOut}
					borderWidths={[0.6, 0.6, 0.6, 0]}
					borderUnits="rem"
					backgroundClass={styles.pullOutBg}
					borderClass={styles.pullOutBorder}
					shadowOffset={4}
					shadowOpacity={0.5}
					shadowBlur={true}
				/>
			);

			if (this.props.demo) {
				pullOut = (
					<div
						className={styles.pullOutWrapper}
						onClick={() => Sounds.playSound("lesson-menu")}
					>
						<Link to={URLMake.forEnroll()} useWonkyCursor={true}>
							{quad}
							<div className={styles.logoutBlock}>
								<span className={styles.enrollNowText}>Exit</span>
							</div>
						</Link>
					</div>
				);
			} else {
				pullOut = (
					<div className={styles.pullOutWrapper} onClick={this.logout}>
						{quad}
						<div className={styles.logoutBlock}>
							<span className={styles.logoutText}>Sign out</span>
						</div>
					</div>
				);
			}
			const avatar = (
				<Avatar
					hasSurround={true}
					className={styles.avatar}
					avatar={avatarModel}
				/>
			);

			let profileButton = null;
			let profileIconClass = styles.profile;
			if (this.props.hideProfile) {
				profileIconClass += " " + styles.hidden;
			}
			profileButton = this.props.hideProfile ? null : (
				<IconButton
					iconEl={avatar}
					iconName={"profile"}
					clickSound="top-bar-icon-1"
					isSelected={
						pageName === "profile.main" && page.currentTab !== "homework"
					}
					iconClass={profileIconClass}
					underlineClass={styles.profileUnderline}
					masked={this.props.masked}
					linkTo={URLMake.forProfileDefault()}
					handleClick={this.props.hijackClick}
					useLinkStyle={!_.isNil(this.props.hijackClick)}
					fadeIn={this.props.fadeIn}
				/>
			);

			const pullOutStyle = this.props.demo
				? styles.demoPullOut
				: styles.pullOut;
			const pullOutActiveStyle = this.props.demo
				? styles.demoPullOutActive
				: styles.pullOutActive;

			const dropdownContainer = this.props.masked ? null : (
				<DropdownContainer
					isActive={this.state.userDropdown}
					activeClassName={pullOutActiveStyle}
					inactiveClassName={pullOutStyle}
					onEnter={this.openDropdown}
					onLeave={this.closeDropdown}
				>
					{pullOut}
				</DropdownContainer>
			);

			const usernameGroup = (
				<div className={styles.usernameGroup}>
					<div className={styles.nameBucks}>
						<div data-hj-suppress className={styles.username}>
							{displayName}
						</div>
						{bucks}
					</div>
					<img
						className={styles.pullArrow}
						src={AssetsUtil.getButton("right", "yellow")}
					/>
				</div>
			);

			if (this.props.isStatic) {
				return (
					<div
						className={this.props.className || styles.main}
						data-testid={PLAYWRIGHT_TEST_IDS.TOP_BAR_USER}
					>
						<div className={styles.outer}>
							<div className={styles.profileStatic}>{avatar}</div>
							<div className={styles.user}>{usernameGroup}</div>
						</div>
						<div className={styles.pullOutStatic}>{pullOut}</div>
					</div>
				);
			} else {
				return (
					<div
						className={this.props.className || styles.main}
						data-testid={PLAYWRIGHT_TEST_IDS.TOP_BAR_USER}
					>
						<div className={styles.outer}>
							{profileButton}
							<HoverRegion
								className={styles.user}
								onEnter={this.openDropdown}
								onLeave={this.closeDropdown}
							>
								{usernameGroup}
							</HoverRegion>
						</div>
						<Portal container={PORTAL_CONTAINERS.USER_PULLOUT_MENU}>
							{dropdownContainer}
						</Portal>
					</div>
				);
			}
		},
	})
);
